import { render } from "./ArrowWithoutCircle.vue?vue&type=template&id=42614151"
const script = {}
script.render = render

export default script